window.addEventListener("DOMContentLoaded", () => {
  $(".hura-messages.swiper-wrapper").slick({
    arrows: true,
    rtl: window.isAr,
    prevArrow: "<button type='button' class='slick-prev'><div> <svg class='prev-button-svg' width='6' height='11' viewBox='0 0 6 11' fill='none' xmlns='http://www.w3.org/2000/svg'><path class='custom-button-svg' fill-rule='evenodd' clip-rule='evenodd' d='M5.16164 10.3233L6 9.48493L1.67671 5.16164L6 0.838358L5.16164 0L0 5.16164L5.16164 10.3233Z' fill='white'/></svg> </div></button>",
    nextArrow: "<button type='button' class='slick-next'><div> <svg class='next-button-svg' width='6' height='11' viewBox='0 0 6 11' fill='none' xmlns='http://www.w3.org/2000/svg'><path class='custom-button-svg' fill-rule='evenodd' clip-rule='evenodd' d='M0.838356 0.676713L-8.46107e-07 1.51507L4.32329 5.83836L-9.01992e-08 10.1616L0.838357 11L6 5.83836L0.838356 0.676713Z' fill='white'/></svg> </div></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $(".hura-messages.swiper-wrapper").show();
  const announcement = document.querySelector(".hura-announcement-bar");
  const announcementSlider = document.querySelector(".hura-messages.slick-slider");
  const svgArrows = document.querySelectorAll(".custom-button-svg");
  const textColor = announcementSlider.querySelector(".slick-active").dataset.color;
  svgArrows.forEach((svg) => {
    svg.setAttribute("fill", textColor);
  });
  announcement.style.background = announcementSlider.querySelector(".slick-active").dataset.background;
  $(".hura-messages.swiper-wrapper").on(
      "beforeChange",
      function(event, slick, currentSlide, nextSlide) {
        announcement.style.background = slick.$slides[nextSlide].dataset.background;
        const textColor2 = slick.$slides[nextSlide].dataset.color;
        svgArrows.forEach((svg) => {
          svg.setAttribute("fill", textColor2);
        });
      }
  );
});